export default "__VITE_ASSET__ZPnWw2l0__"